import validate from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/node_modules/nuxt/dist/pages/runtime/validate.js";
import device_45global from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/middleware/device.global.ts";
export const globalMiddleware = [
  validate,
  device_45global
]
export const namedMiddleware = {}